
function config()
{
  //check setup for config

  return {
    heroMouseMove: true,
    animateTimeline: true,
  }
}


let pageIsLoaded = false

$(window).on('load', function (e){
  pageIsLoaded = true
})

function pageLoaded()
{
  return pageIsLoaded
}

export { config, pageLoaded }